(function () {
    var s = (typeof (Vendd) != "undefined" && Vendd.Scripts) || (typeof (Scripts) != "undefined" && Scripts);
    if (!s) return;
    s.load(function () {
        'use strict';
        var TrackingScriptName = 'Criteo';

        var TrackingModel = LhApp.Function.Tracking.getTrackingModel();
        var Tracker = LhApp.Function.Tracking.getTracker("criteo", TrackingModel);

        if (!Tracker || !Tracker.Properties.CriteoId || !Tracker.Properties.CriteoTMS)
            return;

        var cookieType = Tracker.CookieGroupCode ? Tracker.CookieGroupCode : '';
        var CanTrack = LhApp.Function.Tracking.canTrack(cookieType);

        var _isUserSelectedProduct;

        Init();

        function Init() {
            if (!CanTrack) return;

            $('body').prepend(
                "<!-- Criteo GTM Tag -->" +
                "<script type='text/javascript' src='//static.criteo.net/js/ld/ld.js' async='true'><\/script>" +
                "<!-- End Criteo GTM Tag -->"
            );

            window.criteo_q = window.criteo_q || [];

            window._criteo_q = [
                { event: "setAccount", account: Tracker.Properties.CriteoId },
                { event: "setSiteType", type: (/iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d") }
            ];

            //TRACK order completion
            if (TrackingModel.IsThankYouPage && TrackingModel.CartProductsData && TrackingModel.Order) {
                if (TrackingModel.Order.IsAlreadyTracked)
                    return;

                if (typeof angular !== 'undefined') {
                    angular.element(document).ready(function () {
                        var oScope = angular.element('.x-control.x-angular-control.x-checkoutorder').scope();
                        var tracked = false;
                        if (oScope && !tracked) {
                            if (TrackingModel.IsThankYouPage) //cookie consent had been granted
                            {
                                tracked = true;

                                var checkoutEmail = oScope.Model.Data.Profile.Email.trim().toLowerCase();

                                if (checkoutEmail) {
                                    _criteo_q.push(
                                        { event: "setEmail", email: checkoutEmail }
                                    );
                                }

                                var criteoItems = [];
                                var items = TrackingModel.CartProductsData;
                                for (var i = 0, len = items.length; i < len; i++) {
                                    var product = items[i];
                                    var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                    criteoItems.push({ id: productId, price: product.PriceN, quantity: product.Quantity });
                                };

                                window.criteo_q.push(_criteo_q.concat(
                                    {
                                        event: "trackTransaction",
                                        id: TrackingModel.Order.Id,
                                        item: criteoItems
                                    }
                                ));
                            }
                        }
                    });
                }
            }
        }

        // IMPORTANT execute this scripts in all other pages except checout
        if (typeof (Vendd) != "undefined" && Vendd.Scripts) {

            //On consents update, re-initialize this tracker
            Vendd.MessageBus.subscribe(Vendd.Consents.Messages.InsertAllCookiesSuccess, TrackingScriptName, function () {
                CanTrack = LhApp.Function.Tracking.canTrack(cookieType);
                Init();
            });

            //in the case of criteo we first have to retrive user email before sending trcking in
            Vendd.MessageBus.subscribe(Vendd.User.Messages.GetUserViewModelSuccess, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (envelope && envelope.message && envelope.message.data && envelope.message.data.model) {                    
                    if (envelope.message.data.model.IsAuthenticated && envelope.message.data.model.HashedEmail) {
                        _criteo_q.push(
                            {
                                event: "setEmail",
                                email: envelope.message.data.model.HashedEmail
                            }
                        );
                    }

                    if (TrackingModel.IsHomePage) {
                        window.criteo_q.push(_criteo_q.concat(
                            {
                                event: "viewHome"
                            }
                        ));
                    } else if (TrackingModel.IsProductListPage) {
                        window.criteo_q.push(_criteo_q.concat(
                            {
                                event: "viewList",
                                item: (function () {
                                    var ids = [];
                                    for (var list in TrackingModel.ProductListsData) {
                                        var listItems = TrackingModel.ProductListsData[list];
                                        for (var i = 0; i < listItems.length; i++) {
                                            var product = listItems[i];
                                            var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                                            if (ids.indexOf(productId) < 0)
                                                ids.push(productId);
                                        };
                                    }

                                    return ids;
                                })()
                            }
                        ));
                    } else if (TrackingModel.IsProductDetailsPage && TrackingModel.ProductData && TrackingModel.ProductData.length > 0) {
                        var product = TrackingModel.ProductData[0];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);

                        window.criteo_q.push(_criteo_q.concat(
                            {
                                event: "viewItem",
                                item: productId
                            }
                        ));
                    }
                }
            });

            Vendd.MessageBus.subscribe(Vendd.Product.Messages.SetSelected, TrackingScriptName, function (envelope) {
                //determine if this has been auto raised during product details load in order to avoid tracking twice the product view
                _isUserSelectedProduct = envelope.message.data.visitorInitiated;
            });
            //TRACK product view (changed)
            Vendd.MessageBus.subscribe(Vendd.Product.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (!_isUserSelectedProduct)
                    return;

                var model = envelope.message.data.model;

                var product = model;
                var productId = LhApp.Function.Tracking.getFeedItemId(product, 'ProductChanged', Tracker);

                window.criteo_q.push(_criteo_q.concat(
                    {
                        event: "viewItem",
                        item: productId
                    }
                ));
            });

            Vendd.MessageBus.subscribe(Vendd.Cart.Messages.Changed, TrackingScriptName, function (envelope) {
                if (!CanTrack) return;

                if (TrackingModel.IsCartPage) {

                    var items = envelope.message.data.Cart.Items || [];
                    var criteoItems = [];
                    for (var i = 0, len = items.length; i < len; i++) {
                        var product = items[i];
                        var productId = LhApp.Function.Tracking.getFeedItemId(product, null, Tracker);
                        criteoItems.push({
                            id: productId,
                            price: product.Prices.FinalPriceN ? product.Prices.FinalPriceN : product.Prices.PriceN,
                            quantity: product.Quantity
                        });
                    };

                    if (criteoItems.length > 0) {
                        window.criteo_q.push(_criteo_q.concat(
                            {
                                event: "viewBasket",
                                item: criteoItems
                            }
                        ));
                    }
                }
            });
        }
    });
})();
